import type { ComponentMultiStyleConfig } from "@chakra-ui/react"

import { fieldSizes, fieldStyle } from "./input-definition"

export const Select: ComponentMultiStyleConfig = {
  parts: ["icon", "field"],
  variants: {
    barnes: {
      field: {
        ...fieldStyle,
      },
      icon: {
        color: "textMuted",
      },
    },
  },
  sizes: {
    md: {
      field: { ...fieldSizes.md, pr: 9 },
    },
    sm: {
      field: { ...fieldSizes.sm, pr: 9 },
    },
  },
  defaultProps: {
    size: "md",
    variant: "barnes",
  },
}
